export default __webpack_public_path__ + "static/media/Engineering Physics.646ff5b7.pdf";